module.exports = __webpack_public_path__ + "img/zoom_minus.25d198e2.svg";